import { Tag } from 'antd';
import { CryoType } from 'modules/products/types';
import { CSSProperties, FC } from 'react';

import styles from './styles.module.scss';

type CryoTagProps = {
  type: CryoType;
  className?: string;
  style?: CSSProperties;
};

const CRYO_TAG_CONFIG: Record<CryoType, { color: string }> = {
  'Cryo-rich': { color: 'blue' },
  'Cryo-poor': { color: 'orange' },
};

export const CryoTag: FC<CryoTagProps> = ({ type, className, style }) => {
  const config = CRYO_TAG_CONFIG[type];
  const combinedClassName = `${styles.cryoTag} ${className || ''}`.trim();

  return (
    <Tag color={config.color} className={combinedClassName} style={style}>
      {type}
    </Tag>
  );
};
